import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { DummyComponent } from '../../../shared/dummy.component';
import { PolizaCreditoConst } from './poliza-credito-const';
import { PolizaCredito } from '../../../models/finanzas/poliza-credito/poliza-credito.model';
import { PolizaCreditoService } from '../../../services/finanzas/poliza-credito/poliza-credito.service';
import { PolizaCreditoDialogDeleteComponent } from './poliza-credito-dialog-delete.component';
import { PolizaCreditoDialogFormComponent } from './poliza-credito-dialog-form.component';
import { PolizaCreditoDialogConstitucionComponent } from './poliza-credito-dialog-constitucion.component';
import { PolizaCreditoDialogLiquidacionesComponent } from './poliza-credito-dialog-liquidaciones.component';
import { PolizaCreditoDialogMovimientoBancoComponent } from './poliza-credito-dialog-movimiento-banco.component';
import { PolizaCreditoDialogMovimientoEfectivoComponent } from './poliza-credito-dialog-movimiento-efectivo.component';
import { TableService } from '../../../shared/components/table/table.service';
import { AccountingAccountsService } from '../../accounting/accounting-accounts/accounting-accounts.service';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { AccountingAccountsDialogLedgerComponent } from '../../accounting/accounting-accounts/accounting-accounts-dialog-ledger.component';
import { BankTypeEnum } from '../../../shared/data-types';
import { ReconciliationConnectComponent } from '../../conciliation/connect/reconciliation-connect.component';
import { ReconciliationService } from '../../conciliation/reconciliation.service';
import { SubscriptionService } from '../../subscription/subscription.service';
import { consts } from '../../../consts';
import { Utils } from '../../../shared/utils';
import { BankTransactionImportImportComponent } from '../../conciliation/import/bank-transaction-import.component';

@Component({
    selector: 'convfact-poliza-credito-list',
    templateUrl: './poliza-credito-list.component.html',
    styleUrls: [],
    standalone: false
})
export class PolizaCreditoListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  public headerTable: any[] = PolizaCreditoConst.headerTable;

  public dataSource: PolizaCredito[] = [];

  public empty: boolean = false;
  public ready: boolean = false;
  public spinner: boolean = false;
  public conciliation_active: boolean = false;

  constructor(
    private polizaCreditoService: PolizaCreditoService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public dummy: DummyComponent,
    private tableService: TableService,
    private accountingAccountsService: AccountingAccountsService,
    private reconciliationService: ReconciliationService,
    private subscriptionService: SubscriptionService,
  ) { }

  public ngOnInit(): void {
    this.dataSource = [];
    this.getList();
    this.getSubscriptionActives();
  }

  public getSubscriptionActives() {
    this.subscriptionService.getActive().then(response => {
      if (response && response.length > 0) {
        this.conciliation_active = response.filter(c => c.alias === 'SUBSCRIPTION_RECONCILIATION').length > 0;
      }
    });
  }

  public getList() {
    this.polizaCreditoService.list(this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
          this.getStatusConectionList();
        }
        this.ready = true;
      });
  }

  public pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public create(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PolizaCreditoDialogFormComponent, {
      data: { polizaCredito: undefined, isEditMode: false }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public edit(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const polizaCreditoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PolizaCreditoDialogFormComponent, {
      data: { polizaCredito: polizaCreditoSelected, isEditMode: true }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public constitucion(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const polizaCreditoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PolizaCreditoDialogConstitucionComponent, {
      // height: '50%',
      // width: '60%',
      data: { polizaCredito: polizaCreditoSelected }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public liquidaciones(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const polizaCreditoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PolizaCreditoDialogLiquidacionesComponent, {
      // height: '50%',
      // width: '60%',
      data: { polizaCredito: polizaCreditoSelected }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public movimientobanco(uid: string, tipoMovimientoBancoId: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const polizaCreditoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PolizaCreditoDialogMovimientoBancoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { polizaCredito: polizaCreditoSelected, tipoMovimientoBancoId: tipoMovimientoBancoId }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public movimientoefectivo(uid: string, tipoMovimientoEfectivoId: number): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el obtejo y se lo pasamos al modal de pago
    const polizaCreditoSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(PolizaCreditoDialogMovimientoEfectivoComponent, {
      width: '90%',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { polizaCredito: polizaCreditoSelected, tipoMovimientoEfectivoId: tipoMovimientoEfectivoId }
    })
      .afterClosed().subscribe((changes: boolean) => {

        if (changes) {
          this.dummy.redirectTo(this.router.url)
        }

      });
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(PolizaCreditoDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  public displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public mayor(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    const searchedElement = this.dataSource.find(x => x.uid == uid);

    let accountingModelsResponse: AccountingAccountsModel[] = [];
    let accountingModels: AccountingAccountsModel = new AccountingAccountsModel();

    this.accountingAccountsService.list(0, 1, searchedElement.accountingModelsNumber)
      .subscribe((x: any) => {
        accountingModelsResponse = x.data;

        if (accountingModelsResponse && accountingModelsResponse.length === 1) {
          accountingModels = accountingModelsResponse[0];
        }

        this.dialog.open(AccountingAccountsDialogLedgerComponent, {
          width: '700px',
          maxWidth: '96vw',
          
          maxHeight: '90vh',
          autoFocus: false,
          data: {
            id: accountingModels.id,
            name: accountingModels.name,
            number: accountingModels.number
          }
        });
      });
  }

  public connectBank(uid: string): void {
    if (!Utils.IsTierFive()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(ReconciliationConnectComponent, {
      data: {
        bankId: uid,
        bankTypeId: BankTypeEnum.Poliza,
        bankName: "",
      },
    })
      .afterClosed()
      .subscribe((bankId: string) => {

        if (bankId != null) {

          const bankIndex = this.dataSource.findIndex(x => x.uid == bankId);

          if (bankIndex != -1) {
            this.dataSource[bankIndex].connected = false;
          }

        }

      });
  }

  public reconcile(uid: string): void {
    if (!this.conciliation_active) {
      if (!Utils.IsTierFour()) {
        this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
        return;
      }
    }

    this.router.navigate(["/finance/creditfacility/conciliation"], { queryParams: { bankId: uid, bankTypeId: BankTypeEnum.Poliza } });
  }

  private getStatusConectionList(): void {
    this.reconciliationService
      .getAllBankStatusRequisition()
      .then((response) => {
        if (response == null) {
          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            value.connected = false;
            return value;
          });
        }

        if (response != undefined) {
          const resultUids = response.map((x) => x.bankId);

          this.dataSource = this.dataSource.map((element) => {
            const value = element;
            if (resultUids.includes(value.uid)) {
              value.connected = true;
            } else {
              value.connected = false;
            }
            return value;
          });
        }
      })
      .catch((err) => { });
  }

  public importTransactions(uid: string) {
    if (!this.conciliation_active) {
      if (!Utils.IsTierFour()) {
        this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
        return;
      }
    }

    this.dialog.open(BankTransactionImportImportComponent, {
      data: {
        bankId: uid,
        bankTypeId: BankTypeEnum.Poliza,
      }
    });
  }

  public trackByIndex(i: number) { return i; }

}
